// src/hooks/programs/useForceDeleteProgram.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteProgram } from "../../api/apiPrograms";
import parseError from "../../utils/parseError";

const useForceDeleteProgram = () => {
    const queryClient = useQueryClient();

    const {
        mutate: forceDeleteProgramMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: forceDeleteProgram,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["programs"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to force delete program");
        },
    });

    return {
        forceDeleteProgramMutate,
        isPending: isPending || isLoading,
    };
};

export default useForceDeleteProgram;
